var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countdown"},[(_vm.current <= 10)?_c('div',{staticStyle:{"padding":"5px"}},[_vm._v("Signing-out in "+_vm._s(_vm.current)+" seconds…")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }